import "./SectionHeader.css"

export default function SectionHeader({ children }) {
    return (
        <div className="sectionBlock">
            <div className="centerSectionBlock">
                <div className="sectionLine"></div>
                <h1 className="sectionText">{ children }</h1>
                <div className="sectionLine"></div>
            </div>
        </div>
    )
}